export function filterDocumentItems(items, { query, category }) {
  const normalizedQuery = query.trim().toLowerCase()
  return items.filter((item) => {
    const matchesCategory = category === 'all' || item.category === category
    const matchesQuery =
      !normalizedQuery ||
      item.name.toLowerCase().includes(normalizedQuery) ||
      item.category.toLowerCase().includes(normalizedQuery)
    return matchesCategory && matchesQuery
  })
}
